import { createFromIconfontCN } from "@ant-design/icons";

const MyIcon = createFromIconfontCN({
  // scriptUrl: "//at.alicdn.com/t/c/font_4862045_rjfd0vm0zle.js", // 在 iconfont.cn 上生成
  scriptUrl: "//at.alicdn.com/t/c/font_5044501_4v30jtllyw7.js", // 在 iconfont.cn 上生成
});

//at.alicdn.com/t/c/font_4497761_5gzc5teb2c.css

export default MyIcon;
